import React from 'react';
import Joi from 'joi';

import Form from '../common/form';
import Progress from '../themed/progress';
import SignaturePreview from '../themed/signature-pad/preview';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';
import * as data from '../../utils/data';

import * as authService from '../../services/authService';
import * as service from '../../services/reportService';
import * as toastService from '../../services/toastService';

class ApproveReportForm extends Form {
	state = {
		data: { reportStatus: '', reviewComment: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		reportStatus: Joi.string().required().label('Approval Status'),
		reviewComment: Joi.string().min(7).required().label('Comments'),
	};

	postData = async (): Promise<void> => {
		const project: models.Project | undefined = this.props.project;
		if (!project) return toastService.error('Project not available!');

		await service.approveReport(
			project.report._id,
			this.state.data,
			this.handleProgressChange
		);

		window.location.reload();
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Submitting Approval',
			success: 'Approval Submitted',
			error: utils.getErrorMessage,
		});
	};

	render() {
		const user = authService.getCurrentUser() as models.User;

		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h3 className="form-title">Approve Report </h3>

					{this.renderSelect({
						name: 'reportStatus',
						label: 'Approval Status',
						placeholder: 'Do you approve this report?',
						options: data.getReviewOptions(),
					})}

					{this.renderTextArea({
						name: 'reviewComment',
						label: 'Comments',
						rows: '4',
						placeholder: 'Enter Your Review Comments',
					})}

					{user.signature && <SignaturePreview signatureUrl={user.signature} />}

					<div className="d-flex justify-content-end">
						{this.renderButton('Submit Review')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default ApproveReportForm;
